import React from 'react';
import { Box, Container, Typography, Link, Stack, IconButton, Tooltip } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useNavigate } from 'react-router-dom';

const Footer = ({ userRole }) => {
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[100],
        borderTop: '1px solid #e0e0e0',
        position: 'relative' // Needed for absolute positioning of the admin button
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative' }}>
        
        {/* --- LEFT: Admin Button (Absolute Position) --- */}
        {userRole === 'admin' && (
            <Box sx={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', display: { xs: 'none', sm: 'block' } }}>
                <Tooltip title="Admin Dashboard">
                    <IconButton 
                        size="small" 
                        onClick={() => navigate('/admin')} 
                        sx={{ color: 'text.disabled', '&:hover': { color: 'primary.main' } }}
                    >
                        <AdminPanelSettingsIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        )}

        {/* --- CENTER: Main Content --- */}
        <Stack spacing={2} alignItems="center" justifyContent="center">
          
          {/* Links Row */}
          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Link 
                component="button"
                variant="body2" 
                color="text.secondary" 
                onClick={() => navigate('/roadmap')}
                sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, textDecoration: 'none', '&:hover': { color: 'primary.main' } }}
            >
              <MapIcon fontSize="small" /> Feature Roadmap
            </Link>
          </Box>

          {/* Copyright Row */}
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} Astrup Family Cookbook. All rights reserved.
          </Typography>

        </Stack>

        {/* Mobile Admin Button Fallback (Shows below text on very small screens) */}
        {userRole === 'admin' && (
            <Box sx={{ display: { xs: 'flex', sm: 'none' }, justifyContent: 'center', mt: 2 }}>
                 <IconButton onClick={() => navigate('/admin')} size="small" sx={{ color: 'text.disabled' }}>
                    <AdminPanelSettingsIcon />
                </IconButton>
            </Box>
        )}

      </Container>
    </Box>
  );
};

export default Footer;